import React from 'react';
import Note from './Note';
import SearchMenu, { FilterConsumer } from '../components/SearchMenu';

function NotesSearch() {
  return (
    <SearchMenu>
      <FilterConsumer>{({ agencies }) => <Note filter={agencies} />}</FilterConsumer>
    </SearchMenu>
  );
}

export default NotesSearch;
